import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		color: theme.palette.colors.purplishBlue,
		fontSize: "14px",
		fontFamily: "MuseoSansCyrl-500",
		margin: 0,
	},
}));

const CommonNoTariffsInfo = ({ text }) => {
	const classes = useStyles();

	return <p className={classes.root}>{text}</p>;
};

export default CommonNoTariffsInfo;
